import { createFileRoute } from '@tanstack/react-router';
import { QuienesSomosPage } from '@/features/quienes-somos/pages/quienes-somos-page';

export const Route = createFileRoute('/_public/quienes-somos')({
  component: QuienesSomosPage,
});
